
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#000","fill-rule":"evenodd","d":"M19.804 9.05a2.406 2.406 0 00-.489-.75l-.25-.3a2.414 2.414 0 01-.679-1.62V6a2.336 2.336 0 00-.189-.88 2.456 2.456 0 00-2.196-1.5h-.37a2.496 2.496 0 01-1.627-.69l-.27-.26a2.47 2.47 0 00-3.394 0l-.33.26a2.439 2.439 0 01-1.617.68h-.379A2.478 2.478 0 005.638 6v.37A2.5 2.5 0 014.95 8l-.26.27A2.508 2.508 0 004.21 11c.116.278.282.533.49.75l.25.28c.21.216.376.47.488.75.119.275.183.57.19.87V14c.006.303.07.602.19.88a2.474 2.474 0 002.196 1.5v5.12a.5.5 0 00.5.5h.259c.156 0 .31-.039.45-.11l2.565-1.28c.138-.07.3-.07.439 0l2.566 1.28a.99.99 0 00.449.11h.26a.5.5 0 00.499-.5v-5.12A2.478 2.478 0 0018.377 14v-.37c.023-.61.268-1.189.689-1.63l.26-.27c.673-.72.86-1.77.478-2.68zm-1.926 1.27l-.27.28a4.55 4.55 0 00-1.218 3v.37a.479.479 0 01-.49.46h-.339a4.383 4.383 0 00-2.925 1.2l-.29.27a.479.479 0 01-.339.1.453.453 0 01-.32-.12l-.279-.27a4.54 4.54 0 00-2.995-1.22h-.32a.449.449 0 01-.418-.29.358.358 0 010-.2v-.34a4.345 4.345 0 00-.39-1.56 4.252 4.252 0 00-.868-1.34l-.27-.29a.606.606 0 01-.13-.19.462.462 0 01.08-.5l.27-.28a4.554 4.554 0 001.258-2.95v-.37a.479.479 0 01.489-.46h.34a4.437 4.437 0 002.934-1.22l.29-.27a.482.482 0 01.33-.13.45.45 0 01.319.12l.28.27a4.54 4.54 0 002.994 1.22h.37a.45.45 0 01.419.29.377.377 0 010 .2v.34A4.34 4.34 0 0016.73 8c.202.498.497.952.868 1.34l.27.29a.616.616 0 01.09.15.463.463 0 01-.08.54z","clip-rule":"evenodd"}})])
          )
        }
      }
    